import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type TLatestNewsFilter = {
  tagParent: string;
  setTagParent: (v: string) => void;
  tagKeyword: string;
  setTagKeyword: (v: string) => void;
};

const LatestNewsFilterContext = createContext<TLatestNewsFilter | null>(null);

export const LatestNewsFilterProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [tagParent, setTagParent] = useState('全部');
  const [tagKeyword, setTagKeyword] = useState('');
  const value = useMemo(
    () => ({
      tagParent,
      setTagParent,
      tagKeyword,
      setTagKeyword,
    }),
    [tagParent, tagKeyword],
  );
  return (
    <LatestNewsFilterContext.Provider value={value}>
      {children}
    </LatestNewsFilterContext.Provider>
  );
};

export const useLatestNewsFilter = () => {
  const ctx = useContext(LatestNewsFilterContext);
  if (!ctx) {
    throw new Error(
      'useLatestNewsFilter must be used within LatestNewsFilterProvider',
    );
  }
  return ctx;
};
